import React, { useState } from 'react';

const SpeechSynthesisComponent = () => {
  const [text, setText] = useState('');

  const speakChinese = (text) => {
    if (!window.speechSynthesis) {
      alert('Your browser does not support speech synthesis.');
      return;
    }

    const utterance = new SpeechSynthesisUtterance(text);
    // 尋找中文的語音。這裡假設你的系統或瀏覽器有安裝中文語音
    utterance.voice = window.speechSynthesis.getVoices().find(voice => voice.lang === 'zh-CN');

    if (!utterance.voice) {
      alert('Chinese voice not found. Please check your system settings.');
      return;
    }

    utterance.lang = 'zh-CN';
    window.speechSynthesis.speak(utterance);
  };

  return (
    <div>
      <input
        type="text"
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="輸入中文文字"
      />
      <button onClick={() => speakChinese(text)}>朗讀中文</button>
    </div>
  );
};

export default SpeechSynthesisComponent;
